module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.itemclass === 'focus-areas') ? _c('div', {
    staticClass: "col-3",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.itemname))])])])]) : (_vm.itemclass === 'skills') ? _c('div', {
    staticClass: "col-2",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item small",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.itemname))])])])]) : (_vm.itemclass === 'countries') ? _c('div', {
    staticClass: "col-2",
    on: {
      "click": _vm.toggleItem
    }
  }, [_c('div', {
    staticClass: "picker-item small",
    class: {
      active: _vm.isActive
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemimg
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.itemname))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f02f119e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/PickerItem.vue
// module id = 734
// module chunks = 1